import React, { useEffect, useState } from "react";
import { Phone, MessageSquare, Bot } from "lucide-react";
import { StatusBadge } from "@/components/ds";
import { api } from "@/lib/api";

const tone = (s: string): "green" | "amber" | "slate" =>
  s === "Active" ? "green" : s.includes("Pending") ? "amber" : "slate";

// Module 54 — customer-facing "Your Business Phone" summary. Shows honest capability states and
// NEVER exposes Twilio SIDs / tokens / parent identifiers.
export function BusinessPhoneCard() {
  const [p, setP] = useState<any>(null);
  useEffect(() => { api.telephonyMyProfile().then(setP).catch(() => {}); }, []);
  if (!p) return null;
  const rows = [
    { icon: Phone, label: "Voice (AI receptionist line)", value: p.voice_status },
    { icon: MessageSquare, label: "SMS / Text messaging", value: p.sms_status },
    { icon: Bot, label: "AI Receptionist", value: p.ai_receptionist_status },
  ];
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5" data-testid="business-phone-card">
      <div className="mb-4 flex items-center justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">Your business phone</p>
          <p className="mt-0.5 text-2xl font-semibold text-slate-900" data-testid="business-phone-number">
            {p.phone_number || "Not assigned yet"}
          </p>
        </div>
        <StatusBadge tone={p.activation === "ACTIVE_VOICE_AND_SMS" ? "green" : p.activation === "ACTIVE_VOICE_ONLY" ? "amber" : "slate"} data-testid="business-phone-activation">
          {p.activation === "ACTIVE_VOICE_AND_SMS" ? "Voice + SMS" : p.activation === "ACTIVE_VOICE_ONLY" ? "Voice active" : "Setup in progress"}
        </StatusBadge>
      </div>
      <div className="divide-y divide-slate-100">
        {rows.map((r) => (
          <div key={r.label} className="flex items-center gap-3 py-2.5" data-testid={`phone-row-${r.label.split(" ")[0].toLowerCase()}`}>
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-slate-100 text-slate-500"><r.icon className="h-4 w-4" /></span>
            <span className="flex-1 text-sm text-slate-700">{r.label}</span>
            <StatusBadge tone={tone(r.value)}>{r.value}</StatusBadge>
          </div>
        ))}
      </div>
      {p.blocked_reason && (
        <p className="mt-3 rounded-lg bg-amber-50 px-3 py-2 text-xs text-amber-700" data-testid="business-phone-note">{p.blocked_reason}</p>
      )}
      <p className="mt-3 text-xs text-slate-400">ResFil manages your phone infrastructure — you never need a Twilio account.</p>
    </div>
  );
}
